import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VCard,{staticClass:"logo-card mx-auto mb-8",attrs:{"elevation":"8","max-width":"600"}},[_c(VImg,{staticClass:"white--text align-end",attrs:{"src":require('../assets/logo.jpg'),"gradient":"to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)","height":"250px"}},[_c(VCardTitle,{staticClass:"text-h4 font-weight-bold"},[_vm._v(" MRT Kids Racing ")])],1)],1),_c('ImportRacers',{staticClass:"mb-8"}),_c('Home',{attrs:{"msg":'Benvinguts a la web de control de cursa MRT'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }